import React from 'react'
import { useApolloClient } from '@apollo/react-hooks'

import { useAccesses } from "lib/accesses"
import { useModal } from "lib/modal"
import { useTranslation } from "lib/i18n/translation"
import { CREATE_UNSUBSCRIBE_INFORMATION } from 'lib/graphql'

import ConfirmTerminate from "components/modals/confirm-terminate"
import UpdatePaymentMethod from "components/modals/update-payment-method"
import ConfirmReactivate from 'components/modals/confirm-reactivate'

const SubscriptionActions = () => {
	const { show } = useModal()
	const { subscription, isSubscriptionFromStripe } = useAccesses()
	const { c } = useTranslation("common")
	const client = useApolloClient()

	const updatePaymentMethod = (subscription) => {
		show({
			id: "update-payment-method",
			title: c("update-payment-method"),
			children: <UpdatePaymentMethod access={subscription} />,
			className: "modal short"
		})
	}

	const confirmReactivate = (subscription) => {
			show({
				id: "confirm-terminate",
				children: <ConfirmReactivate access={subscription} />,
				className: "modal short"
			})
	}

	const confirmTerminate = (subscription) => {
		client
					.mutate({
						mutation: CREATE_UNSUBSCRIBE_INFORMATION,
						variables: {
							unsubscribeInformation: {
								subscriptionId: parseInt(subscription.id),
								subscriptionProductId: parseInt(subscription.product.id),
								subscriptionName: subscription.product.name,
								hasCancelled: false,
							}
						},
						context: { clientName: "adminKinow" }
					})

		show({
			id: "confirm-terminate",
			children: <ConfirmTerminate access={subscription} />,
			className: "modal"
		})
	}

	if (!subscription.product.extension.autoRenewal) {
		return <span className="centered">-</span>
	}

	if (!subscription.recurring) {
		if (subscription.order
			&& !isSubscriptionFromStripe()
		) {
			return <span>{c("canceled")}</span>
		}

		return <a
			href="#"
			onClick={e => {
				e.preventDefault()
				confirmReactivate(subscription)
			}}
			rel="nofollow noopener"
			title={c("terminate-renew")}
			className='button small icon-blank'
		>
			{c("terminate-renew")}
		</a>
	}

	return (
		<>
			{isSubscriptionFromStripe() && (
				<>
					<a
						href="#"
						onClick={e => {
							e.preventDefault()
							updatePaymentMethod(subscription)
						}}
						rel="nofollow noopener"
						title={c("update-payment-method")}
						className='button small icon-edit'
					>
						{c("update-payment-method")}
					</a>
				</>
			)}
			<a
				href="#"
				onClick={e => {
					e.preventDefault()
					confirmTerminate(subscription)
				}}
				rel="nofollow noopener"
				title={c("terminate")}
				className='button small icon-blank'
			>
				{c("terminate")}
			</a>
		</>
	)
}

export default SubscriptionActions
